<script setup lang="ts">import { toRef as _toRef, ref as _ref } from 'vue';

import { onClickOutside } from '@vueuse/core'
import { useScreen } from '@consumer/helpers/screen'
import FlyOutCaret from '../FlyOut/FlyOutCaret.vue'

withDefaults(defineProps<{
  withCaret?: boolean
  duration?: number
}>(), { withCaret: true,duration: 3000, })

defineOptions({
  inheritAttrs: false,
})

const __$temp_1 = (useScreen()),
  isDesktop = _toRef(__$temp_1, 'isDesktop');

const open = (defineModel<boolean>('open', { default: false }))

let localOpen = _ref(open.value)

const emit = defineEmits(['close'])

const toast = useTemplateRef<HTMLDivElement>('fly-out-toast')

let timeout = _ref<ReturnType<typeof setTimeout>>()

watch(
  () => localOpen.value,
  () => {
    if (localOpen.value) {
      scheduleClose()
    }
    else {
      // Closing the toast
      clearLocalTimeout()
      // Allow some time for the fade-out transition to complete
      setTimeout(() => emit('close'), 300)
    }
  },
)

watch(
  () => open.value,
  () => localOpen.value = open.value,
)

function scheduleClose () {
  if (localOpen.value) {
    clearLocalTimeout()
    timeout.value = setTimeout(() => { localOpen.value = false }, __props.duration)
  }
}

onMounted(() => localOpen.value && scheduleClose())

function clearLocalTimeout () {
  if (timeout.value) {
    clearTimeout(timeout.value)
    timeout.value = undefined
  }
}

onClickOutside(toast, (e) => {
  const target = e.target as HTMLElement
  if (!target.closest('.fly-out-toast')) { localOpen.value = false }
})
</script>

<template>
  <Teleport to="#toasts" :disabled="isDesktop">
    <Transition name="fade-in-out">
      <V2Card
        v-if="localOpen"
        ref="fly-out-toast"
        style="box-shadow: 0 2.52px 22.52px 9px #0000000f;"
        class="
        fly-out-toast
        clickable border-none
        <lg:fixed <lg:z-100 <lg:bottom-4 <lg:right-2 <lg:w-max <lg:min-w-max
      "
        v-bind="$attrs"
      >
        <div v-if="open" style="min-height: 62px;">
          <slot/>
        </div>
        <!-- caret -->
        <FlyOutCaret v-if="isDesktop && withCaret" style="top: -8px;"/>
      </V2Card>
    </Transition>
  </Teleport>
</template>
